import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";

import MDBox from "components/MDBox";

interface Props {
  height?: string | number;
}

function CardSkeleton({ height = "20rem" }: Props): JSX.Element {
  return (
    <Card sx={{ overflow: "hidden" }}>
      <MDBox p={2}>
        <MDBox display="flex" alignItems="center" mb={1.5}>
          <Skeleton
            variant="rounded"
            animation="wave"
            width="3rem"
            height="3rem"
            sx={{ mr: 2, flexShrink: 0 }}
          />
          <MDBox width="100%">
            <Skeleton animation="wave" width="55%" height={28} />
            <Skeleton animation="wave" width="40%" height={20} />
          </MDBox>
        </MDBox>
        <Skeleton variant="rounded" animation="wave" width="100%" height={height} />
      </MDBox>
    </Card>
  );
}

export default CardSkeleton;
